var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPmBankTransferInstant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 10.4l-1.8 1.7L4 13.8h3v-3.4H7zm0 15.4l-1.8 1.7L4 29.2h3v-3.4H7zM4 18l-1.8 1.7L4 21.5h3v-3.4H7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.2 8.7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26.3 11c0-1.8-1.4-3.1-3.2-3.1a3.2 3.2 0 00-3.2 3c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 22.2h37.8V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.1 18.8h23.2V3.5H11v15.3zm25.3 3.4H9l-1.4-1.6v-19L9 .1h27.4l1.4 1.5v19l-1.4 1.6z",
    mask: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmBankTransferInstant);
export default __webpack_public_path__ + "static/media/pm-bank-transfer-instant.987606b536deb1bde6ebd0c796cfb0e8.svg";
export { ForwardRef as ReactComponent };